module.exports = __webpack_public_path__ + "barber-model-desktop-c24554.webp";